module.exports = __webpack_public_path__ + "static/media/cosentino-supplies.eb2ce0ce.jpg";